"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeFind = void 0;
const monet_1 = require("monet");
const find_1 = __importDefault(require("ramda/src/find"));
const { fromNull } = monet_1.Maybe;
function safeFind(fn, x) {
    return arguments.length === 2
        ? fromNull((0, find_1.default)(fn, x || []))
        : (y) => fromNull((0, find_1.default)(fn, y || []));
}
exports.safeFind = safeFind;
//# sourceMappingURL=safeFind.js.map